// extracted by mini-css-extract-plugin
export default {"fontFamily":"\"GT America\",helvetica,arial,sans-serif"};